var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgYoutube({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9482_4866)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.5406 6.41902C22.4218 5.94443 22.1799 5.5096 21.8392 5.15843C21.4986 4.80726 21.0713 4.55221 20.6006 4.41902C18.8806 3.99902 12.0006 3.99902 12.0006 3.99902C12.0006 3.99902 5.12057 3.99902 3.40057 4.45902C2.92982 4.59221 2.50255 4.84726 2.16192 5.19843C1.82129 5.5496 1.57936 5.98443 1.46057 6.45902C1.14579 8.20458 0.991808 9.97533 1.00057 11.749C0.989351 13.5361 1.14334 15.3203 1.46057 17.079C1.59153 17.5389 1.83888 17.9572 2.17872 18.2935C2.51855 18.6298 2.93939 18.8728 3.40057 18.999C5.12057 19.459 12.0006 19.459 12.0006 19.459C12.0006 19.459 18.8806 19.459 20.6006 18.999C21.0713 18.8658 21.4986 18.6108 21.8392 18.2596C22.1799 17.9085 22.4218 17.4736 22.5406 16.999C22.8529 15.2666 23.0069 13.5094 23.0006 11.749C23.0118 9.96198 22.8578 8.17772 22.5406 6.41902Z",
    stroke: "#272727",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 15.0205L15.5 11.7505L9.75 8.48047V15.0205Z",
    stroke: "#272727",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9482_4866"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.a229a98a02f533b2200d84bad1334962.svg";
export { ForwardRef as ReactComponent };